import { combineReducers } from "redux";
import timecard from "./timecard";
import imageObject from "./imageObject";
import { reducer as formReducer } from "redux-form";
import approveTimecard from "./approveTimecard";
import rejectTimecard from "./rejectTimecard";
import rejectionValidation from "./rejectionValidation";
import employeeDetails from "./employeeDetails";
import filterData from "./filterData";
import authInfo from "./authInfo";

const rootReducer = combineReducers({
  timecard,
  imageObject,
  approveTimecard,
  rejectTimecard,
  rejectionValidation,
  employeeDetails,
  filterData,
  authInfo,
});

export default rootReducer;
